export const C_APPLICANT_SAVE_BUTTON = 16
export const C_APPLICANT_EDIT_BUTTON = 17
export const C_APPLICANT_DELETE_BUTTON = 18
export const C_USER_SAVE_BUTTON = 19
export const C_USER_EDIT_BUTTON = 20
export const C_USER_DELETE_BUTTON = 21
export const C_RECOGNITION_SAVE_BUTTON = 22
export const C_RECOGNITION_EDIT_BUTTON = 23
export const C_RECOGNITION_DELETE_BUTTON = 24
export const C_INSTITUTION_SAVE_BUTTON = 25
export const C_INSTITUTION_EDIT_BUTTON = 26
export const C_INSTITUTION_DELETE_BUTTON = 27
export const C_APPLICANT_NEW_BUTTON = 28
export const C_APPLICANT_RECOGNITION_PDF_BUTTON = 29
export const C_DOCUMENT_DOWNLOAD_BUTTON = 30
export const C_DOCUMENT_DELETE_BUTTON = 31
export const C_CONTACT_SAVE_BUTTON = 32
export const C_CONTACT_DELETE_BUTTON = 33
export const C_USER_NEW_BUTTON = 34
export const C_APPLICANT_RECOGNITION_EDIT_BUTTON = 35
export const C_APPLICANT_RECOGNITION_VIEW_BUTTON = 36
export const C_GENERATE_DECISION = 37
export const C_STATUS = 38
export const C_APPLICANT_FILTER_ECONOMY = 39
export const C_APPLICANT_FILTER_INSTITUTION = 40
export const C_UPLOAD_DOCUMENTS = 41
